import { apiClient } from './ApiClient';
import { ReleaseResponse } from './ReleaseService';
export type DeploymentAttempt = {
  startTime: string;
  deployedBy: string | undefined;
  tags: string[];
  forceInstall: boolean;
};
type Deployment = {
  id: string;
  releaseId: string;
  jobId: string;
  status: string;
  tagIds: string[];
  forceInstall: boolean;
  attempts: DeploymentAttempt[];
  createTime: string;
  lastUpdateTime: string;
  consoleJobUrl: string;
  tags: string[];
};
export type DeploymentInput = {
  releaseId: string;
  tagIds: string[];
  tags?: string[];
  forceInstall: boolean;
};
type DeploymentResponse = {
  id: string;
  releaseId: string;
  release: ReleaseResponse;
  jobId: string;
  status: string;
  tagIds: string[];
  tags: string[];
  forceInstall: boolean;
  createdAt: string;
  updatedAt: string;
};

export const getDeployments = async (status: string): Promise<Deployment[]> => {
  const response = await apiClient
    .getClient()
    .get(`deployments/?status=${status}`);
  return response.data;
};

export const getDeployment = async (id: string): Promise<Deployment> => {
  const response = await apiClient.getClient().get(`deployments/${id}`);
  return response.data;
};

export const createDeployment = async (
  input: DeploymentInput,
): Promise<DeploymentResponse> => {
  const response = await apiClient.getClient().post(`deployments`, input);
  return response.data;
};

export const getStableVersion = async (): Promise<DeploymentResponse> => {
  const response = await apiClient
    .getClient()
    .get(`deployments/stable-version`);
  return response.data;
};

export const setStableVersion = async (releaseId: string) => {
  const response = await apiClient
    .getClient()
    .post(`deployments/stable-version`, { releaseId });
  return response.data;
};
